import AlertDialogModal from '../../ui/primitives/AlertDialog'

interface ConfirmModalProps {
  title: string
  message: string | JSX.Element
  confirmation: string
  color?: 'error' | 'warning' | 'primary'
  danger?: boolean
  onClose?: () => void
  onConfirm?: () => void
}

export default function ConfirmModal({
  title,
  message,
  confirmation,
  color = 'error',
  danger,
  onClose,
  onConfirm,
}: ConfirmModalProps) {
  const isDanger = danger ?? color === 'error'

  return (
    <AlertDialogModal
      open
      onClose={onClose ?? (() => {})}
      title={title}
      description={message}
      confirmLabel={confirmation}
      danger={isDanger}
      onConfirm={() => onConfirm?.()}
    />
  )
}
